<template>
    <div
        class="signs-calculator"
    >
        <span
            v-for="(item, key) in setting"
            :key="key"
            class="signal__container"
        >
            <span>{{item.text}}：</span>
            <v-icon :class="item.icon[0]">{{ item.icon[1] }}</v-icon>
            <span v-if="signs_count[item.value]">x {{ signs_count[item.value] }}</span>
        </span>
    </div>
</template>

<script>
    export default {
        name: 'SignsCalculator',
        
        props: {
            data: {
                type: Array,
                require: true,
                default: () => [],
            },
            setting: {
                type: Array,
                require: true,
                default: () => [
                    { text: '預警', icon: ['signal--warning', 'icon-pentagon'], value: '3'},
                    { text: '警戒', icon: ['signal--alert', 'icon-square'], value: '2'},
                    { text: '行動', icon: ['signal--action', 'icon-triangle'], value: '1'},
                ],
            },
            sort_type: {
                type: String,
                default: 'int_case'
            },
        },

        data() {
            return{ 
                
            }
        },

        computed: {
            signs_count() {
                return this.sort_func(this.data)
                    .reduce((accumulator, value) => {
                        const { signs_num } = value
                        if (signs_num === '-') return accumulator
                        const sign_count = accumulator[signs_num]
                        return {
                            ...accumulator,
                            ...{
                                [signs_num]: sign_count ? sign_count + 1 : 1
                            }
                        }
                    }, {})
            }
        },

        methods: {
            sort_func() {
                if (this.sort_type === 'int_case') {
                    return this.sort_by_int_case()
                } else if(this.sort_type === 'city_case') {
                    return this.sort_by_city_case()
                }

                return this.data
            },

            sort_by_int_case() {
                return [...this.data]
                    .sort(this._sorter_by_signs_num())
                    .filter(this._first_item_with_same_idx())
                    .sort((a, b) => a.idx - b.idx)
            },

            sort_by_city_case() {
                const CITY_ORDERS = ["基隆市", "臺北市", "新北市", "桃園市", "新竹縣", "苗栗縣", "臺中市", "南投縣", "彰化縣", "雲林縣", "嘉義縣", "臺南市", "高雄市", "屏東縣", "宜蘭縣", "花蓮縣", "臺東縣"];
                return [...this.data]
                    .sort(this._sorter_by_signs_num())
                    .filter(this._first_item_with_same_idx())
                    .sort((a,b) => CITY_ORDERS.findIndex(city => city === a.idx) - CITY_ORDERS.findIndex(city => city === b.idx))
            },

            _sorter_by_signs_num() {
                return (a, b) => {
                    if (a.signs_num !== "-" && b.signs_num !== "-"){
                        return a.signs_num - b.signs_num
                    } else if (a.signs_num !== "-" && b.signs_num === "-"){
                        return -1
                    } else if (a.signs_num === "-" && b.signs_num !== "-"){
                        return 1
                    }
                }
            },

            _first_item_with_same_idx() {
                return (value, index, self) => {
                    const first_same_idx_item_index = self.findIndex(item => item.idx === value.idx)
                    return first_same_idx_item_index === index
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin.scss';
    @import '../../../../css/monitor/sign.scss';

    .signs-calculator {
        display: flex;
        gap: .25rem;
        // margin-right: 1.5rem;
    }

    .signal__container {
        display: flex;
        align-items: center;

        @include mobile {
            margin: 0;
        }
    }
</style>